import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-checkout-ship-to-rdd',
  templateUrl: './checkout-ship-to-rdd.component.html',
  styleUrls: ['./checkout-ship-to-rdd.component.scss'],
})
export class CheckoutShipToRddComponent {
  @Input() shipToObj: any;
  @Input() isOrderPlaced: Boolean = false;
  @Input() isOrderDetails: Boolean = false;
  @Input() orderData: any;
  placedOnDate: any;
}
